<template>
    <!-- FIXME: Clear this up heavily-->
    <v-app>


        <edit-menu v-if="$root.edit && $store.state.editMenu" />

        <edit-panel v-if="$root.edit && !$store.state.editMenu && !isInIframe" :selectedcomponent="$root.selectedEditComponent" ref="editpanel" />

        <div v-if="!isInIframe && $root.edit && $root.revisionPreview !== null">
            <div style="margin-left: 460px" class="d-flex my-4">
                <div class="d-flex flex-column ml-4">
                    <div class="headline">{{$translate('Here below version {0} is shown').format($root.revisionPreview.id)}}</div>
                    <div>{{$root.revisionPreview.created}}, {{$root.revisionPreview.author}}</div>
                </div>

                <v-btn class="mx-8" @click="$root.revertToRevision($root.revisionPreview.id)" color="error">{{$translate('Restore to this version')}}<v-icon>mdi-restore</v-icon></v-btn>
                <v-btn color="primary" @click="$root.revisionPreview = null">{{$translate('Return to current version')}}</v-btn>
            </div>
            <iframe
                :key="revisionRenderKey"
                style="position: absolute; left: 460px; top: 80px; width: calc(100% - 460px); height: 100vh; border: none; z-index: 100"
                v-if="!isInIframe && $root.edit && $root.revisionPreview !== null"
                :src="thisHref + '?revision_id=' + $root.revisionPreview.id"
            ></iframe>
        </div>

        <v-main
            v-show="!$root.mobilePreview && $root.revisionPreview == null"
        >
            <div class="d-flex fill-width" v-if="$root.edit">
                <v-card flat tile class="ma-2" v-if="!$root.siteconfig.root.props.appComponent || $root.siteconfig.root.props.appComponent.component == 'zoezi-empty'">
                    <v-card-title class="headline zoezi-edit-color">
                        Välj en appkomponent genom att trycka på knappen till höger
                    </v-card-title>
                </v-card>
                <component-wrapper class="fill-width"
                                   :config="$root.siteconfig.root.props.appComponent"
                />
            </div>
            <router-view />

            <edit-popover v-if="$root.edit && $store.state.editMenu && $store.state.editComponent" :component="$store.state.editComponent" />

            <v-btn v-if="!$root.edit && !isInIframe && hasEditPermission && !noEditMode && !isExpoApp()"
                   @click="$root.setEditMode()"
                   :loading="$store.state.editModeInitializing"
                   color="zoezi-edit-color"
                   fab
                   bottom
                   left
                   fixed
                   style="z-index: 20;"
                   :style="{bottom: $vuetify.breakpoint.mobile ? 'calc(56px + 16px)' : '16px'}"
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </v-main>

        <component-wrapper v-if="$vuetify.breakpoint.mobile"
                           :config="$root.siteconfig.bottombar"
        />

        <!-- FIXME: Used in edit mode? -->
        <error-dialog />
        <snack-bar />
        <portal-target name="toolbox" multiple />
        <confirm-dialog />
    </v-app>
</template>

<script>
import {merge, debounce} from 'lodash'
import SnackBar from '../components/SnackBar.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'
import { getUrlParameterThis, isExpoApp } from '../util.js'
import components from '../component.js'

export default {
    name: 'zoezi-root',

    zoezi: {
        title: 'Root',
        icon: 'mdi-file-tree-outline',
        internal: true,
        type: 'sf'
    },
    props: {
        appComponent: {
            type: Object,
            title: 'App component',
            fulltype: 'component',
            default: () => components.makeEmptyConfig()
        }
    },

    data: () => ({
        mobileRenderKey: 0,
        revisionRenderKey: 0,
        debouncedUndo: null,
        debouncedRedo: null
    }),
    components: {
        SnackBar,
        ConfirmDialog,
    },
    watch: {
        '$root.siteconfig': {
            deep: true,
            handler(siteconfig) {
                let iframe = this.$refs.mobilePreview;
                if (this.$root.edit && iframe && iframe.contentWindow) {
                    iframe.contentWindow.postMessage({action: 'setSiteConfig', data: siteconfig});
                }
            }
        },
        '$root.revisionPreview'() {
            this.revisionRenderKey++;
        },
        '$store.state.isLoggedIn'(isLoggedIn) {
            if (!isLoggedIn) {
                // FIXME: If we have logged out from within resource booking we don't want to navigate away
                //this.goto('/');
                console.log('Should goto /')
            }
        },
        '$store.state.editComponent'() {
            if (this.isInIframe) {
                console.log('Postmessage of setEditComponent for id ' + this.$store.state.editComponentConfig?.id )
                window.top.postMessage({action: 'setEditComponent', data: this.$store.state.editComponentConfig?.id });
            }
        }
    },
    computed: {
        showGroupInviteDialog() {
            const groupInviteQuery = this.$root.siteconfig.pages.mypagesGroupInvite || 'groupinvite';
            return !!this.$route.query[groupInviteQuery];
        },
        isInIframe() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        thisHref() {
            return window.location.protocol + '//' + window.location.host + window.location.pathname;
        },
        noEditMode() {
            return !!getUrlParameterThis('noeditmode');
        },
        hasEditPermission() {
            return this.$store.state.isLoggedIn && this.$store.state.user && !!this.$store.state.user.permissions.find(x => x == 'Change homepage') && this.$store.state.settings && (this.$store.state.settings.zoeziMyBusiness == 'flex' || (this.$store.state.settings.zoeziMyBusiness == 'basic' && this.$store.state.user.superUser));
        },
        numBookings() {
            let b = this.$store.getters.comingBookings;
            if (!b) {
                return 0;
            }

            let res = 0;
            if (b.workouts) {
                res += b.workouts.length;
            }

            if (b.resourcebookings) {
                res += b.resourcebookings.length
            }

            if (b.coursebookings) {
                res += b.coursebookings.length;
            }

            return res;
        }
    },
    methods: {
        isExpoApp,
        mobilePreviewLoaded() {
            this.$root.mobilePreviewLoading = false;
        },
        goto(link) {
            if (this.$route.path != link) {
                this.$router.push({path: link});
            }
        },
        gotoMyPages() {
            let link = this.$root.getDefaultPage('mypages');
            if (this.$route.path != link) {
                this.goto(link);
            } else {
                this.$vuetify.goTo(0);
            }
        },
        fetchAndProcessRevisions(action) {
            if (!this.$root.edit) {
                return;
            }
            this.$api.get('/api/homepage/revision/get', {homepage_id: this.$root.homepage_id})
                .then(data => {
                    const revisions = data;
                    const revision_id = this.$root.revisionPreview ? this.$root.revisionPreview.id : this.$root.current_revision_id;
                    const currentRevisionIndex = revisions.findIndex(rev => rev.id == revision_id);

                    if (action === 'undo' && currentRevisionIndex < revisions.length - 1) {
                        this.$root.revisionPreview = revisions[currentRevisionIndex + 1];
                    } else if (action === 'redo') {
                        this.$root.revisionPreview = currentRevisionIndex > 0 ? revisions[currentRevisionIndex - 1] : null;
                    }
                });
        },
        undo() {
            this.fetchAndProcessRevisions('undo');
        },
        redo() {
            this.fetchAndProcessRevisions('redo');
        },
        addKeyListeners() {
            document.addEventListener('keydown', (event) => {
                if (event.ctrlKey && event.key === 'z') {
                    this.debouncedUndo();
                } else if (event.ctrlKey && event.key === 'y') {
                    this.debouncedRedo();
                }
            });
        },
    },

    created() {
        this.debouncedUndo = debounce(this.undo, 300);
        this.debouncedRedo = debounce(this.redo, 300);
        window.addEventListener("message", (event) => {
            if (!event.data) {
                return;
            }

            if (event.data.action == 'setEditComponent') {
                let found;

                let findComponentConfigById = function(x, id) {
                    if (Array.isArray(x)) {
                        x.forEach(c => {
                            findComponentConfigById(c, id);
                        });
                    } else if (x) {
                        if (x.id == id) {
                            found = x;
                        } else if (typeof x === 'object') {
                            Object.values(x).forEach(c => {
                                findComponentConfigById(c, id);
                            })
                        }
                    }
                };

                console.log('Got Postmessage of setEditComponent for id ' + event.data.data)

                findComponentConfigById(this.$root.siteconfig, event.data.data)
                console.log(found)

                if (found) {
                    this.$store.dispatch('setEditComponentConfig', {config: found, parentComponent: null});
                }
            } else if (event.data.action == 'setRoute') {
                this.$root.followLink(event.data.data);
            } else if (event.data.action == 'setSiteConfig' && event.source == window.top) {
                merge(this.$root.siteconfig, event.data.data);
            }
        });

        if (this.$root.edit) {
            this.addKeyListeners();
        }
    }
};

</script>
